$(document).ready(function () {

  "use strict";
  // navbar js start ---
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 10) {
      $(".navbar").addClass("nav-fixed");
    } else {
      $(".navbar").removeClass("nav-fixed");
    }
  });

  $(".ham-menu").click(function (event) {
    event.stopPropagation();
    $(".navbar-links-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".navbar-links-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".mobile-menu-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".navbar-links-wrapper").removeClass("active");
    $(".ham-menu").removeClass("active");
    $(".navbar-links-inner").removeClass("active");
    $("body").removeClass("active");
  });

  // mobile-dropdown responsive accordion js start--
  $(function () {
    let isMobile = window.matchMedia(
      "only screen and (max-width: 992px)"
    ).matches;

    if (isMobile) {
      // **..mobile-dropdown-accordion js start..**
      $(".navbar-link-content").slideUp();
      $(".navbar-link-title").on("click", function () {
        $(this).next(".navbar-link-content").slideToggle();
        $(this).parent().toggleClass("active");
        $(this)
          .parent()
          .siblings()
          .removeClass("active")
          .find(".navbar-link-content")
          .slideUp();
      });
      // **..mobile-dropdown-accordion js end..**
    }

    // mobile-dropdown responsive accordion js start--
    $(function () {
      let isMobile = window.matchMedia(
        "only screen and (max-width: 992px)"
      ).matches;

      if (isMobile) {
        $(".dropdown-sub-menu").slideUp();
        // **..mobile-dropdown-accordion js start..**
        $(".dropdown-btn1").on("click", function () {
          $(this).next(".dropdown-sub-menu1").slideToggle();
          $(this).toggleClass("active");
        });
        // **..mobile-dropdown-accordion js end..**

        // **..mobile-dropdown-accordion js start..**
        $(".dropdown-btn2").on("click", function () {
          $(this).next(".dropdown-sub-menu2").slideToggle();
          $(this).toggleClass("active");
        });
        // **..mobile-dropdown-accordion js end..**
      }
    });
    // mobile-dropdown responsive accordion js end--
  });
  // mobile-dropdown responsive accordion js end--

  $(".search-bar-open-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar-overlay").addClass("active");
    $(".search-bar-close-window-btn").addClass("active");
    $("body").addClass("active");
  });

  $(".search-bar-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar-overlay").removeClass("active");
    $(this).removeClass("active");
    $("body").removeClass("active");
  });

  $(".search-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar-overlay").removeClass("active");
    $(".search-bar-close-window-btn").removeClass("active");
    $("body").removeClass("active");
  });

  // navbar js end ---

  // --slide-tab js start--
  // $(".slide-tab-btn").click(function () {
  //   $(this).parent().siblings(".tab-nav-item").removeClass("active");
  //   $(this).parent().addClass("active");
  //   $(".slide-tab-content-item").hide();
  //   var activeTab = $(this).attr("href");
  //   $(activeTab).fadeIn();
  //   return false;
  // });
  // --slide-tab js end--

  // --grid-tab js start--
  $(".grid-tab-btn").click(function () {
    $(this).parent().siblings(".tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".grid-tab-content-item").hide();
    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  // --grid-tab js end--

  // video review popup js start---
  $(".video-review-content").click(function (event) {
    event.stopPropagation();
    $(".video-review-popup").addClass("active");
  });

  $(".video-review-popup-close").click(function (event) {
    event.stopPropagation();
    $(".video-review-popup").removeClass("active");
  });
  // video review popup js end---

  // size-chart-sidebar js start---
  $(".size-sidebar-btn").click(function (event) {
    event.stopPropagation();
    $(".size-chart-sidebar").addClass("active");
    $(".size-chart-sidebar-inner").addClass("active");

    $("body").addClass("active");
  });

  $(".size-chart-sidebar-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".size-chart-sidebar").removeClass("active");
    $(".size-chart-sidebar-inner").removeClass("active");
    $("body").removeClass("active");
  });

  $(".size-chart-close-btn").click(function (event) {
    event.stopPropagation();
    $(".size-chart-sidebar").removeClass("active");
    $(".size-chart-sidebar-inner").removeClass("active");
    $("body").removeClass("active");
  });
  // size-chart-sidebar js end---

  // cart-sidebar js start---
  $(".side-cart-btn").click(function (event) {
    event.stopPropagation();
    window.dispatchEvent(new CustomEvent('open-cart-drawer'));
  });

  $(".cart-sidebar-close-window-btn, .side-cart-close-btn").click(function (event) {
    event.stopPropagation();
    // Alpine's @click on these buttons handles closing, 
    // but we can also dispatch an event if needed.
    // For now, let's just let Alpine handle it.
  });
  // cart-sidebar js end---

  // collection filter sidebar js start--
  $(".filter-open-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").addClass("active");
    $("body").addClass("active");
  });

  $(".filter-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").removeClass("active");
  });

  $(".filter-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").removeClass("active");
  });
  // collection filter sidebar js end--

  // **..collection filter-accordion js start..**
  $(".accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
  });
  // **..collection filter-accordion js end..**

  // **..product-accordion js start..**
  $(".product-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".product-accordion-item-content")
      .slideUp();
  });
  // **..product-accordion js end..**

  // sticky-add-to-cart-section js start--
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 1100) {
      $(".sticky-add-to-cart-section").addClass("fixed");
    } else {
      $(".sticky-add-to-cart-section").removeClass("fixed");
    }
  });
  // sticky-add-to-cart-section js end--

  // **..faq-accordion js start..**
  $(".faq-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".faq-accordion-item-content")
      .slideUp();
  });
  // **..faq-accordion js end..**


  // gift-card-slider js start--
  var swiper = new Swiper(".gift-card-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    grabCursor: true,
    loop: false,
    navigation: {
      nextEl: ".gift-card-slider-button-next",
      prevEl: ".gift-card-slider-button-prev",
    },
    breakpoints: {
      1: {
        spaceBetween: 10,
        slidesPerView: 1.7,
      },
      576: {
        spaceBetween: 20,
        slidesPerView: 2.3,
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 3.2,
      },
      993: {
        spaceBetween: 20,
        slidesPerView: 4,
      },
      1361: {
        spaceBetween: 20,
        slidesPerView: 4,
      },
    },
  });
  // gift-card-slider js end--

  // datepicker js end--
});

// btn js ---
// primary btn---
$(function () {
  $(".primary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});

// secondary btn--
$(function () {
  $(".secondary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});
// btn js ---

// topbar slider js start--
var swiper = new Swiper(".top-bar-slider", {
  slidesPerView: 1,
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// topbar slider js end--

// hero slider js start--
var swiper = new Swiper(".hero-slider", {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,
  speed: 1000,
  effect: "fade",
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".hero-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".hero-button-next",
    prevEl: ".hero-button-prev",
  },
  breakpoints: {
    // when window width is <= 767px (mobile)
    0: {
      navigation: false, // hides arrows
    },
    576: {
      navigation: false, // hides arrows
    },
    // when window width is > 767px (desktop)
    768: {
      navigation: {
        nextEl: ".hero-button-next",
        prevEl: ".hero-button-prev",
      }
    }
  }
});
// hero slider js end--

// category-slider js start--
var swiper = new Swiper(".category-slider", {
  slidesPerView: 6,
  spaceBetween: 24,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".category-slider-button-next",
    prevEl: ".category-slider-button-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 2.7,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 3.7,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
    1201: {
      spaceBetween: 24,
      slidesPerView: 6,
    },
  },
});
// category-slider js end--

// collection-tab-slide js start--
var swiper = new Swiper(".collection-tab-slide", {
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".collection-tab-slide-button-next",
    prevEl: ".collection-tab-slide-button-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 1.7,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.2,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});
// collection-tab-slide js end--

// card-slider js start--
var swiper = new Swiper(".card-slider", {
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".card-slider-button-next",
    prevEl: ".card-slider-button-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 1.7,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.2,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});
// card-slider js end--

// video-review-slider js start--
var video_review_slider = new Swiper(".video-review-slider", {
  loop: true,
  speed: 500,
  autoplay: {
    delay: 2000,
  },
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: "auto",
  coverflowEffect: {
    rotate: 0,
    stretch: 80,
    depth: 200,
    modifier: 1,
    slideShadows: false,
  },
});
// video-review-slider js end--

// related-product-slider js start--
var swiper = new Swiper(".related-product-slider", {
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".related-product-slider-btn-next",
    prevEl: ".related-product-slider-btn-prev",
  },

  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 1.7,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.2,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});
// related-product-slider js end--

// side-cart-slider js start--
var swiper = new Swiper(".side-cart-slider", {
  slidesPerView: 2.2,
  spaceBetween: 10,
  grabCursor: true,
  loop: false,
  speed: 1000,
});
// side-cart-slider js end--

// product-slider js start---
// var swiper = new Swiper(".product-slider-thumb", {
//   direction: "vertical",
//   loop: false,
//   spaceBetween: 20,
//   slidesPerView: 5,
//   freeMode: true,
//   mousewheel: true,
//   breakpoints: {
//     // when window width is >= 320px
//     1: {
//       direction: "horizontal",
//       spaceBetween: 10,
//       slidesPerView: 4,
//     },
//     // when window width is >= 576px
//     576: {
//       direction: "horizontal",
//       spaceBetween: 20,
//       slidesPerView: 5,
//     },
//     // when window width is >= 767px
//     768: {
//       direction: "vertical",
//       spaceBetween: 20,
//       slidesPerView: 5,
//     },
//     // when window width is >= 767px
//     993: {
//       direction: "vertical",
//     },
//   },
// });
// var swiper2 = new Swiper(".product-slider", {
//   loop: true,
//   autoHeight: true,
//   spaceBetween: 10,
//   slidesPerView: 1,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//    pagination: {
//     el: ".product-pagination",
//     clickable: true,
//   },
//   thumbs: {
//     swiper: swiper,
//   },
//   breakpoints: {
//     // when window width is >= 320px
//     1: {
//       spaceBetween: 5,
//       slidesPerView: 1.15,
//     },
//     // when window width is >= 576px
//     576: {
//       spaceBetween: 5,
//       slidesPerView: 1.15,
//     },
//     // when window width is >= 767px
//     768: {
//       spaceBetween: 0,
//       slidesPerView: 1,
//     },

//   },
// });
// product-slider js start---
var swiper = new Swiper(".product-slider", {
  loop: true,
  autoHeight: true,
  spaceBetween: 0,
  speed: 800,
  pagination: {
    el: ".swiper-pagination-product",
    clickable: true,
  },
  navigation: {
    nextEl: ".product-slider-btn-next",
    prevEl: ".product-slider-btn-prev",
  },
});
$(document).ready(function () {
  // product quantity js start--//
  $(".qty-increase").click(function () {
    // $("#quantity").val(parseInt($(".quantity-total").val()) + 1);
    $(".quantity-total").val(
      parseInt($(".quantity-total").val()) + 1
    );
  });

  $(".qty-decrease").click(function () {
    var currentValue = parseInt($(".quantity-total").val());
    if (currentValue > 1) {
      $(".quantity-total").val(currentValue - 1);
      // $("#quantity").val(currentValue - 1);
    }
  });

  // Change image when product option changes
  $(".product-option-select").on("change", function () {
    let optionName = "";
    let thisText = $(this).find('option:selected').text();
    $(this).parent().parent().find('.selected_option').text(thisText);
    // Get selected option value
    $(".product-option-select option:selected").each(function (e) {
      optionName += e !== 0 ? "-" : "";
      optionName += $(this).val();
    });

    $("#productSelect option").each(function () {
      var txt = $.trim($(this).text());
      if (txt === optionName) {
        var img = $(this).data("img");
        var id = $(this).val();
        var price = $(this).data("price");
        var compare_price = $(this).data("compare");
        var available = $(this).data("available");
        $("#productSelect").val(id);
        // $("#product_id").val(id);

        if (available) {
          $(".addToCart").removeClass("sold_out");
          $(".atc-text").text("Add To Cart");
        } else {
          $(".addToCart").addClass("sold_out");
          $(".atc-text").text("Sold Out");
        }

        // $(".thumb_image img").each(function (index) {
        //   var src = $(this).attr("src").split("?")[0]; // Remove query parameters
        //   var cleanImg = img.split("?")[0];
        //   if (src === cleanImg) {
        //     swiper2.slideToLoop(index, 500, false);
        //     $(".thumb_image").removeClass("active"); // Remove active class from all
        //     $(this).closest(".thumb_image").addClass("active"); // Add to selected
        //   }
        // });
      }
    });
  });

  // share button js start--
  $(".share-btn").on("click", function (e) {
    e.preventDefault();
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          url: window.location.href,
        })
        .catch(console.error);
    } else {
      // Fallback: Copy to clipboard
      const el = document.createElement("input");
      el.value = window.location.href;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      alert("Product link copied to clipboard!");
    }
  });
  // share button js end--
});
// product-slider js end---

// progesss-bar js start--
const progress = document.querySelector(".progress");
if (progress) {
  progress.addEventListener("input", function () {
    const value = this.value;
    this.style.background = `linear-gradient(to right,rgb(133 168 104) 0%,rgb(133 168 104) ${value}%,rgb(216, 216, 216) ${value}%)`;
  });
}
// progesss-bar js end--
